$(document).ready(function () {
    setListenersToNotifications();
    $(document).on("ajaxComplete", function(event, xhr, settings) {
        setListenersToNotifications(); //jestlize se ajaxem prenactou buttony co triggeruji eventy, musi se znovu nastavit listenery 
    });
});

function setListenersToNotifications()
{
    var notificationDivs = $('div[data-notification-name]');
    notificationDivs.each(function (index, notificationDivElement) {
        var notificationDiv = $(notificationDivElement);
        var closeBtnElement = notificationDiv.find('a.inline-notification__close-button');
        var notificationName = notificationDiv.data('notification-name');
        var buttonWithNotificationName = $('.' + notificationName);

        if (buttonWithNotificationName.length > 0) {
            buttonWithNotificationName.on('click', function (event) {
                //console.log(event, $(this));
                notificationDiv.css('display','none');
                //zastavi prubeh animace pokud nekdo rychle klika na 2 buttony po sobe, animace znova
                notificationDiv.removeClass('notification-animation__scroll-down-and-up');
                setTimeout(function(){
                    notificationDiv.addClass('notification-animation__scroll-down-and-up');
                    showNotification(notificationName);
                },5);
                
            });
        }

        notificationDiv.on('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function (event) {
            //muzu z event.target.attributes vytahnout data na end animaci
            notificationDiv.removeClass('notification-animation__scroll-down-and-up--abort');
            notificationDiv.addClass('notification-animation__scroll-down-and-up');
            notificationDiv.css('display','none');
        });

        if (closeBtnElement.length > 0) {
            closeBtnElement.on('click', function (event) {
                //zastavi prubeh animace a rovnou odjizdi nahoru (abort)
                notificationDiv.removeClass('notification-animation__scroll-down-and-up');
                notificationDiv.addClass('notification-animation__scroll-down-and-up--abort');
                //var customAnimationEndEvent = jQuery.Event('animationend', { notificationDiv: notificationDiv });
                //notificationDiv.trigger(customAnimationEndEvent);
            });
        }
    });
}

global.showNotification = function (dataNotificationName) {
    var inlineNotification = $(`div[data-notification-name="${dataNotificationName}"]`);
    inlineNotification.css('display', 'block');
}